import { render, staticRenderFns } from "./PickOrderDetail.vue?vue&type=template&id=6930ef23&scoped=true"
import script from "./PickOrderDetail.vue?vue&type=script&lang=js"
export * from "./PickOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PickOrderDetail.vue?vue&type=style&index=0&id=6930ef23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930ef23",
  null
  
)

export default component.exports